// extracted by mini-css-extract-plugin
export var footer = "layout-module--footer--3iD_9";